import React from "react";
import HoverCard from "./HoverCard";
import StarRating from "./StarRating";

const GameCard = ({ 
  game, 
  variant = "light", // "light" or "dark"
  showRating = false,
  showUserRating = false
}) => {
  // Determine styling based on variant
  const cardStyles = {
    light: {
      container: "bg-white",
      title: "text-gray-900",
      date: "text-gray-600",
      rating: "text-yellow-600",
      ratingCount: "text-gray-500",
      hoverShadow: "group-hover:shadow-blue-300/50"
    },
    dark: {
      container: "bg-gray-800",
      title: "text-white",
      date: "text-gray-400",
      rating: "text-yellow-400",
      ratingCount: "text-gray-400",
      hoverShadow: "group-hover:shadow-blue-500/50"
    }
  };

  const styles = cardStyles[variant];

  return (
    <div className="relative group w-full max-w-xs">
      {/* Basic Card */}
      <div className={`${styles.container} p-4 rounded-xl shadow transition duration-300 ${styles.hoverShadow}`}>
        <img
          src={game.cover}
          alt={game.title}
          className="w-full h-44 object-contain rounded mb-4"
        />
        <h3 className={`font-semibold text-lg text-center ${styles.title}`}>
          {game.title}
        </h3>
        <p className={`text-sm text-center ${styles.date}`}>
          {game.releaseDate ? `Released on ${game.releaseDate}` : 'Release date TBA'}
        </p>
        
        {/* Optional Rating Display */}
        {showRating && game.rating && (
          <p className={`text-sm text-center mt-1 ${styles.rating}`}>
            Rating: {game.rating}
            {game.rating !== "N/A" && game.ratingCount > 0 && (
              <span className={`text-xs ml-1 ${styles.ratingCount}`}>
                ({game.ratingCount} ratings)
              </span>
            )}
          </p>
        )}

        {/* User Rating Stars */}
        {showUserRating && (
          <div className="flex justify-center mt-2">
            <StarRating 
              gameId={game.id} 
              size="sm"
              onRatingChange={(rating) => {
                console.log(`User rated ${game.title} ${rating} stars`);
              }}
            />
          </div>
        )}
      </div>

      {/* Hover Card Component */}
      <HoverCard gameId={game.id} />
    </div>
  );
};

export default GameCard; 